module.exports = __webpack_public_path__ + "static/img/MU.77fe0e04.svg";